import React from "react";
import { CircularProgress } from "@material-ui/core";
import moment from "moment-timezone";
import styled from "styled-components";

import {
  getMovAssetServProvider,
  executeServProvider
} from "../../../../../../../../providers/asset-provider";
import {
  withStyles,
  Dialog,
  DialogTitle,
  Grid,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  Button,
  Input,
  IconButton,
  Tooltip,
  TextField
} from "@material-ui/core";
import Select2 from "../../../../../../../../components/Menu/Select";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";

import PageIcon from "@material-ui/icons/NoteAdd";
import Send from "@material-ui/icons/Send";

const styles = theme => ({
  inputPageTitle: {
    fontSize: 16,
    marginRight: "20px",
    minWidth: "100%",
    "&:focus": {
      outline: 0
    }
  },
  widgetNew: {
    backgroundColor: "#ededed",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      cursor: "pointer"
    }
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 320,
    width: "100%"
  }
});

const TableStyled = styled.table`
  border-collapse: collapse;
  width: 100%;

  th,
  td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  tbody tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

class MovementAssetService extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      start_date: null,
      loading: false,
      supplier: null,
      dialogSendService: false,
      selectedAssetServiceId: null
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    getMovAssetServProvider()
      .then(data => {
        this.setState({
          data,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.error("getMovAssetServProvider", error);
      });
  }

  mapPropsToSelect = data => {
    let values = data.map(item => {
      let value = {};
      value["label"] = `${item.asset_model_service.name} > ${item.asset.name}`;
      value["id"] = item.id;
      value["asset_model_service_id"] = item.asset_model_service.id;
      return value;
    });

    return values;
  };

  saveExecuteService = () => {
    if (
      this.state.start_date == null ||
      this.state.supplier == null ||
      this.state.selectedAssetServiceId == null
    ) {
      toast.error("Please, fill requesteds fields.", {
        position: "top-right",
        // autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true
        // draggable: true
      });

      return;
    }

    this.setState({ loading: true });

    executeServProvider(
      this.state.start_date,
      this.state.supplier,
      this.state.selectedAssetServiceId
    )
      .then(data => {
        this.setState({
          dialogSendService: false
        });

        getMovAssetServProvider()
          .then(data => {
            this.setState({
              data,
              loading: false
            });

            toast.success("Service executed with success!!!", {
              position: "top-right",
              // autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true
              // draggable: true
            });
          })
          .catch(error => {
            this.setState({ loading: false });
            console.error("getMovAssetServProvider", error);
          });
      })
      .catch(error => {
        this.setState({ dialogSendService: false, loading: false });
        toast.error("Failed on execute service!!!", {
          position: "top-right",
          // autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true
          // draggable: true
        });
      });
  };

  cancelExecuteService = () => {
    this.setState({
      dialogSendService: false
    });
  };

  executeService = () => {
    this.setState({
      dialogSendService: true
    });
  };

  changeValue = event => {
    this.setState({
      supplier: event.target.value
    });
  };

  changeValueSelectService = value => {
    this.setState({
      selectedAssetServiceId: value
    });
  };

  handleChangeDate = e => {
    this.setState({ start_date: e });
  };

  render() {
    const { classes } = this.props;

    if (this.state.loading) {
      return (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
          <span
            style={{
              marginTop: 20
            }}
          >
            Loading...
          </span>
        </div>
      );
    }

    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          overflow: "auto"
        }}
      >
        <TableStyled>
          <thead>
            <th>Date</th>
            <th>Action name</th>
            <th>Service name</th>
            <th>Asset</th>
            <th>Asset model</th>
            <th>System</th>
            <th>Supplier</th>
            <th>User</th>
          </thead>
          <tbody>
            {this.state.data.map((item, indexItem) => {
              return (
                <tr key={indexItem}>
                  <td>
                    {moment(item.log.log_time).format("YYYY-MM-DD HH:mm")}
                  </td>
                  <td>{item.log.procedure}</td>
                  <td>{item.asset_service.asset_model_service.name}</td>
                  <td>{item.asset_service.asset.name}</td>
                  <td>{item.asset_service.asset.asset_model.name}</td>
                  <td>{item.asset_service.asset_model_service.system.name}</td>
                  <td>{item.supplier}</td>
                  <td>{item.log.user_hash}</td>
                </tr>
              );
            })}
          </tbody>
        </TableStyled>

        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px"
          }}
        >
          <Tooltip title="Execute Service" placement="left">
            <Button
              variant="fab"
              color="primary"
              aria-label="Add"
              onClick={this.executeService.bind(this)}
            >
              <Send />
            </Button>
          </Tooltip>
        </div>

        <Dialog
          open={this.state.dialogSendService}
          aria-labelledby="dialog_widget_new"
          maxWidth="sm"
          fullWidth={true}
        >
          <DialogTitle id="confirmation-dialog-title">
            Execute Service
          </DialogTitle>
          <DialogContent>
            <form className={classes.container} noValidate>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="supplier-new">Supplier</InputLabel>
                <Input id="supplier-new" onChange={this.changeValue} />
              </FormControl>

              <FormControl className={classes.formControl}>
                <Select2
                  options={this.mapPropsToSelect(this.props.services_ids)}
                  label="Service ID"
                  value={this.state.selectedWidget}
                  onChange={this.changeValueSelectService.bind(this)}
                  height={30}
                />
              </FormControl>

              <FormControl className={classes.formControl}>
                <DatePicker
                  customInput={
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="widget-title-new">Date</InputLabel>
                      <Input
                        id="widget-title-new"
                        value={
                          this.state.start_date
                            ? moment(this.state.start_date).format(
                                "YYYY-MM-DD HH:mm"
                              )
                            : "Select Date"
                        }
                      />
                    </FormControl>
                  }
                  dateFormat="MMMM d, yyyy"
                  selected={this.state.start_date}
                  onChange={this.handleChangeDate}
                  maxDate={new Date()}
                />
              </FormControl>
            </form>

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.cancelExecuteService}>
              Cancel
            </Button>
            <Button
              onClick={this.saveExecuteService}
              style={{ backgroundColor: "#e65100", color: "#fff" }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(MovementAssetService);
